var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { CollaboratorTicket, PacketTicket, getAfiliateFromSale } from '../Model';
import { toDateTime, toNumberDecimal } from 'helpers/Format';
import { TT, T } from '../../../helpers/i18n';
import { Action } from '../index';
import { twoDigits } from '../../../helpers/Utils';
import { typeList } from '../Store';
import Storage from '../../../helpers/Storage';
import { dateMonthsBefore } from '../../../helpers/Date';
import { loading } from '../../../elements/Loading';
import { Range } from '../../DashboardTicket/Model';
import CollaboratorPacketTicket from '../../CollaboratorPacketTickets/Model';
import XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import Stretch from '../../Stretches/Model';
import queryString from 'query-string';
import history from '../../../helpers/History';
import { DataListBy, Filter, ListBy, TerminalSale } from '../../DashboardTicket/Util/Mapea';
import CollaboratorStretch from '../../CollaboratorStretches/Model';
import TicketSalesView from './TicketSalesView';
import moment from 'moment';
var TicketSales = /** @class */ (function (_super) {
    __extends(TicketSales, _super);
    function TicketSales() {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        _this = _super.apply(this, arguments) || this;
        _this.state = {
            showDialog: false,
            itemSelected: {},
            listHeaders: listHeaders
            // ticketToRender: undefined,
            // ticketCorrectedToRender: undefined
        };
        _this.afiliateOptions = __spreadArray([{ name: 'sin afiliado', value: String(-1) }], (_a = _this.props.afiliates) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            return { name: item.name, value: String(item.id) };
        }), true);
        _this.collaboratorOptions = (_b = _this.props.collaborators) === null || _b === void 0 ? void 0 : _b.map(function (item) {
            return { name: item.name, value: String(item.client_id) };
        });
        _this.operatorOptions = (_c = _this.props.operators) === null || _c === void 0 ? void 0 : _c.map(function (item) {
            return { name: item.name, value: String(item.client_id) };
        });
        _this.stretchOptions = (_d = _this.props.stretches) === null || _d === void 0 ? void 0 : _d.map(function (item) {
            return { name: item.name, value: String(item.id) };
        });
        _this.csOptions = (_e = _this.props.cs) === null || _e === void 0 ? void 0 : _e.map(function (item) {
            return { name: item.name, value: String(item.id) };
        });
        _this.packetOptions = (_f = _this.props.packets) === null || _f === void 0 ? void 0 : _f.map(function (item) {
            return { name: item.name, value: String(item.id) };
        });
        _this.cpOptions = (_g = _this.props.cp) === null || _g === void 0 ? void 0 : _g.map(function (item) {
            return { name: item.name, value: String(item.id) };
        });
        _this.parseLocation = function () {
            var parsed = queryString.parse(_this.props.location.search);
            var temp = _this.state.itemSelected;
            temp[Filter.ListBy] = parsed[Filter.ListBy] || ListBy.DateSale;
            if (parsed[Filter.Afiliate]) {
                var key = Filter.Afiliate;
                if (_this.props.afiliates) {
                    var finded = _this.props.afiliates.find(function (item) { return item.id === Number(parsed[Filter.Afiliate]); });
                    temp[key] = parsed[key];
                }
            }
            if (parsed[Filter.Operator]) {
                if (_this.props.operators) {
                    var key_1 = Filter.Operator;
                    var finded = _this.props.operators.find(function (item) { return item.client_id === Number(parsed[key_1]); });
                    // tengo duda de si en el query no existe hacer el filtrado o no, de momento lo hace
                    temp[key_1] = parsed[key_1];
                }
            }
            if (parsed[Filter.Stretch]) {
                var key_2 = Filter.Stretch;
                if (_this.props.stretches) {
                    var finded = _this.props.stretches.find(function (item) { return item.id === Number(parsed[key_2]); });
                    // tengo duda de si en el query no existe hacer el filtrado o no, de momento lo hace
                    temp[key_2] = parsed[key_2];
                }
            }
            if (parsed[Filter.CollaboratorStretch]) {
                var key_3 = Filter.CollaboratorStretch;
                if (_this.props.cs) {
                    var finded = _this.props.cs.find(function (item) { return item.id === Number(parsed[key_3]); });
                    temp[key_3] = parsed[key_3];
                }
            }
            if (parsed[Filter.Collaborator]) {
                var key_4 = Filter.Collaborator;
                if (_this.props.collaborators) {
                    var finded = _this.props.collaborators.find(function (item) { return item.id === Number(parsed[key_4]); });
                    temp[key_4] = parsed[key_4];
                }
            }
            if (parsed[Filter.Packet]) {
                var key_5 = Filter.Packet;
                if (_this.props.packets) {
                    var finded = _this.props.packets.find(function (item) { return item.id === Number(parsed[key_5]); });
                    temp[key_5] = parsed[key_5];
                }
            }
            if (parsed[Filter.CollaboratorPacket]) {
                var key_6 = Filter.CollaboratorPacket;
                if (_this.props.cp) {
                    var finded = _this.props.cp.find(function (item) { return item.id === Number(parsed[key_6]); });
                    temp[key_6] = parsed[key_6];
                }
            }
            if (parsed[Filter.TerminalSale]) {
                var key = Filter.TerminalSale;
                temp[key] = parsed[key];
            }
            _this.setState({ itemSelected: temp });
        };
        _this.findUser = function (lista, id) {
            var result = lista.find(function (value) { return value.id === id; });
            return result ? result.name : '';
        };
        _this.handleOnSelectItem = function (item) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // history.push(`/tickets/${item.id}`, item)
                this.ticketToRender = item;
                this.setState({ showDialog: true });
                return [2 /*return*/];
            });
        }); };
        _this.handleToggle = function () {
            // this.setState({ticketToRender: undefined, showDialog: false})
            _this.setState({ showDialog: false }, function () {
                _this.ticketToRender = null;
            });
        };
        _this.handleRefunded = function (response) {
            // console.log('TicketSales - handleRefunded')
            if (response.message) {
                alert(response.message);
                if (_this.props.action === Action.Collaborator) {
                    _this.props.store.reports.readCollaboratorTickets();
                }
                else if (_this.props.action === Action.Operator) {
                    _this.props.store.reports.readOperatorTickets(getData(_this.getTypeListBy()));
                }
                else {
                    _this.props.store.reports.readGeneralSales(getData(_this.getTypeListBy()));
                }
                // this.onToggle()
            }
        };
        _this.handleChangeAdditionalNote = function (response) {
            if (_this.props.action === Action.Collaborator) {
                _this.props.store.reports.readCollaboratorTickets();
            }
            else if (_this.props.action === Action.Operator) {
                _this.props.store.reports.readOperatorTickets(getData(_this.getTypeListBy()));
            }
            else {
                _this.props.store.reports.readGeneralSales(getData(_this.getTypeListBy()));
            }
        };
        _this.getTypeListBy = function () {
            var itemSelected = _this.state.itemSelected;
            var lb = itemSelected[Filter.ListBy];
            if (lb === undefined) {
                lb = ListBy.DateSale;
            }
            if (!DataListBy.hasOwnProperty(lb)) {
                var msg = "listBy ".concat(itemSelected[Filter.ListBy], " no v\u00E1lida");
                console.log(msg);
                return _this.props.store.UI.newError(msg);
            }
            return DataListBy[lb];
        };
        _this.handleChangeFrom = function (_, from) {
            var data = getData(_this.getTypeListBy());
            data.start = from;
            // this.props.store.reports.readGeneralSales(data)
        };
        _this.handleChangeTo = function (_, to) {
            var data = getData(_this.getTypeListBy());
            data.end = to;
            // this.props.store.reports.readGeneralSales(data).then(value => {})
        };
        _this.handleClickOK = function (from, to) {
            var data = getData(_this.getTypeListBy());
            data.start = from;
            data.end = to;
            if (_this.props.action === Action.Ticket) {
                _this.props.store.reports.readGeneralSales(data).then(function (value) { });
            }
            else if (_this.props.action === Action.Operator) {
                _this.props.store.reports.readOperatorTickets(data);
            }
        };
        _this.handleExport = function (data, bookType) {
            var _headers = _this.headers.map(function (header) { return ({
                name: header,
                head: header,
                exportHead: header,
                selected: true
            }); });
            var headers = __spreadArray(__spreadArray([], _this.state.listHeaders, true), _headers, true);
            handleExport(data, bookType, headers);
        };
        //
        _this.handleChangeSelect = function (name, value, column) {
            // const value = e.target.value
            if (column === Filter.ListBy ||
                column === Filter.Afiliate ||
                column === Filter.Stretch ||
                column === Filter.Collaborator ||
                column === Filter.Operator ||
                column === Filter.CollaboratorStretch ||
                column === Filter.Packet ||
                column === Filter.TerminalSale) {
                var temp = _this.state.itemSelected;
                if (!value || (column === Filter.TerminalSale && value === 'all') || (column === Filter.ListBy && value === ListBy.DateSale)) {
                    delete temp[column];
                }
                else {
                    temp[column] = value;
                }
                history.replace({
                    search: queryString.stringify(temp)
                });
                _this.setState({ itemSelected: temp });
            }
        };
        _this.format = function (tickets) {
            var result = tickets.map(function (ticket) {
                var _a, _b;
                return (__assign(__assign({}, ticket), { 
                    // @ts-ignore
                    hasAllocations: ticket.hasAllocations === true ? TT('yes') : '', status: ticket.daterefund === null ? T('valid') : T('canceled'), time: ticket.datecheck.getTime(), typeSale: ticket instanceof CollaboratorPacketTicket
                        ? 'paquete colaboracion'
                        : ticket instanceof PacketTicket
                            ? 'paquete propio'
                            : ticket instanceof CollaboratorTicket
                                ? 'colaboracion'
                                : 'propio', typeInstance: ticket instanceof CollaboratorPacketTicket
                        ? 'CollaboratorPacketTicket'
                        : ticket instanceof PacketTicket
                            ? 'PacketTicket'
                            : ticket instanceof CollaboratorTicket
                                ? 'CollaboratorTicket'
                                : 'Ticket', businessUnit: ticket.businessUnitName, operationLine: ticket instanceof CollaboratorPacketTicket
                        ? ''
                        : ticket.operationLineName, stretch: ticket instanceof PacketTicket ||
                        ticket instanceof CollaboratorPacketTicket
                        ? ''
                        : ticket.stretchName, packet: ticket instanceof PacketTicket ||
                        ticket instanceof CollaboratorPacketTicket
                        ? ticket.packetName
                        : '', dateCheck: moment(ticket.datecheck).format('DD/MM/YYYY HH:mm:ss'), 
                    // dateCheck: toDateTime(ticket.datecheck),
                    // datevalited: ticket instanceof PacketTicket || ticket instanceof CollaboratorPacketTicket ? '' : !ticket.daterefund?ticket.datevalited? toDateTime(ticket.datevalited): 'sin validar' : T('canceled'),
                    /*discount: ticket.typeDiscount !== TypeDiscount.Fix && ticket.discount>0? `${T('percentage')} ${toPercentage(ticket.discount/100)}` :
                      (ticket.totalDiscount || ticket.discount) > 0? `${T('fix')} ${toMoney(ticket.totalDiscount || ticket.discount)}` : '',*/
                    // totalDiscount: toMoney(ticket.totalDiscount, ticket.money),
                    tramoHorario: ticket instanceof PacketTicket ||
                        ticket instanceof CollaboratorPacketTicket
                        ? ''
                        : ticket.tramoHora
                            ? tramoHora((_a = ticket.datebookNTZ) !== null && _a !== void 0 ? _a : ticket.datebook, ticket.hours, ticket.minutes)
                            : 'NO', dateBook: ticket instanceof PacketTicket ||
                        ticket instanceof CollaboratorPacketTicket
                        ? ''
                        : ticket.datebook
                            ? datebookString(ticket)
                            : 'NO', 
                    // netAmount: toMoney(ticket.netAmount, ticket.money),
                    // taxAmount: toMoney(ticket.taxAmount, ticket.money),
                    /*taxBase: toMoney(ticket.taxBase),*/
                    // total: toNumberDecimal(ticket.total), // toMoney(ticket.total, ticket.money),
                    totalNet: ticket.totalNet, 
                    // user: ticket.user// this.findUser(this.props.store!.users.users, ticket.user_id)
                    /*user: this.findUser(this.props.store!.users.users, ticket.user_id)*/
                    user: ticket.username, tipoPago: _this.handleTipoPago(ticket), operatorName: ticket instanceof CollaboratorTicket
                        ? ticket.operatorName
                        : '', afiliateName: (_b = ticket.afiliateName) !== null && _b !== void 0 ? _b : getAfiliteFromPayments(ticket.payments), contactName: getContactName(ticket.contact), contactPhone: getContactPhone(ticket.contact), contactEmail: getContactEmail(ticket.contact), contactAdditional: getContactAdditional(ticket.contact) }));
            });
            return result;
        };
        _this.keyExtractor = function (ticket) {
            return "".concat(ticket.typeSale, "_").concat(String(ticket.id));
        };
        /*static getDerivedStateFromError(error) {
          console.log('error: ', error)
          return {hasError: true}
        }*/
        _this.handleChangeDateFilter = function (value) {
            _this.handleChangeSelect(Filter.ListBy, value, Filter.ListBy);
            var data = getData(value === ListBy.DateSale ? typeList.Report : typeList.Calendar);
            if (_this.props.action === Action.Ticket) {
                _this.props.store.reports.readGeneralSales(data);
            }
            else if (_this.props.action === Action.Operator) {
                _this.props.store.reports.readOperatorTickets(data);
            }
        };
        _this.handleTipoPago = function (ticket) {
            if (ticket.payments.length > 0) {
                var result = ticket.payments.reduce(function (previousValue, currentValue, currentIndex) {
                    if (currentIndex !== ticket.payments.length - 1) {
                        return previousValue + T(currentValue.method) + ', ';
                    }
                    return previousValue + T(currentValue.method);
                }, '');
                return result;
            }
            else {
                return T(ticket.tipoPago);
            }
        };
        return _this;
    }
    TicketSales.prototype.componentDidMount = function () {
        // console.log('TicketSales - componentDidMount')
        /*if (this.props.action === Action.Collaborator) {
          this.props.store.reports.readCollaboratorTickets()
        } else if (this.props.action === Action.Operator) {
          this.props.store.reports.readOperatorTickets()
        } else if (this.props.action === Action.Virtual) {
          const _from = Storage.get('lastDateFrom') as any
          const _to = Storage.get('lastDateTo') as any
          const from = _from? new Date(_from): dateMonthsBefore(new Date(), 1)
          const to = _to? new Date(_to): new Date()
    
          const data = {
            typeList: typeList.Report,
            start: from,
            end: to
          }
          this.props.store.reports.readVirtualTickets(data)
        }*/
        this.parseLocation();
    };
    TicketSales.prototype.render = function () {
        var _this = this;
        var reports = this.props.store.reports;
        if (reports.error) {
            return (React.createElement("div", null, "Se ha producido un error, por favor contacte con el servicio t\u00E9cnico. Error 900"));
        }
        var headers = this.state.listHeaders.reduce(function (previousValue, currentValue) {
            if (currentValue.selected) {
                previousValue.push(currentValue.head);
            }
            return previousValue;
        }, []);
        if (this.props.action === Action.Operator) {
            headers.unshift('collaboratorName');
        }
        if (this.props.action === Action.Collaborator) {
            headers.unshift('operatorName');
        }
        var items;
        if (this.props.action === Action.Collaborator) {
            items = reports.collaboratorTickets;
        }
        else if (this.props.action === Action.Operator) {
            items = reports.operatorTickets;
        }
        else if (this.props.action === Action.Virtual) {
            items = reports.virtualTickets;
        }
        else {
            items = reports.generalTickets;
        }
        if (this.state.itemSelected && this.state.itemSelected[Filter.Afiliate]) {
            var id_1 = Number(this.state.itemSelected[Filter.Afiliate]);
            if (id_1 < 0) {
                items = items.filter(function (item) { var _a; return !((_a = getAfiliateFromSale(item)) === null || _a === void 0 ? void 0 : _a.afiliate_id); });
            }
            else {
                items = items.filter(function (item) { var _a; return ((_a = getAfiliateFromSale(item)) === null || _a === void 0 ? void 0 : _a.afiliate_id) === id_1; });
            }
        }
        if (this.state.itemSelected && this.state.itemSelected[Filter.Operator]) {
            items = items.filter(function (item) {
                return item.operator_id === Number(_this.state.itemSelected[Filter.Operator]);
            });
        }
        if (this.state.itemSelected && this.state.itemSelected[Filter.Collaborator]) {
            items = items.filter(function (item) {
                return item.client_id === Number(_this.state.itemSelected[Filter.Collaborator]);
            });
        }
        if (this.state.itemSelected && this.state.itemSelected[Filter.Stretch]) {
            items = items.filter(function (item) {
                return !(item instanceof CollaboratorTicket ||
                    item instanceof PacketTicket ||
                    item instanceof CollaboratorPacketTicket) &&
                    item.stretch_id === Number(_this.state.itemSelected[Filter.Stretch]);
            });
        }
        if (this.state.itemSelected &&
            this.state.itemSelected[Filter.CollaboratorStretch]) {
            items = items.filter(function (item) {
                return !(item instanceof PacketTicket ||
                    item instanceof CollaboratorPacketTicket ||
                    item instanceof Stretch) &&
                    item.stretch_id ===
                        Number(_this.state.itemSelected[Filter.CollaboratorStretch]);
            });
        }
        if (this.state.itemSelected && this.state.itemSelected[Filter.Packet]) {
            items = items.filter(function (item) {
                return !(item instanceof CollaboratorStretch ||
                    item instanceof CollaboratorPacketTicket ||
                    item instanceof Stretch) && item.packet_id === Number(_this.state.itemSelected[Filter.Packet]);
            });
        }
        if (this.state.itemSelected &&
            this.state.itemSelected[Filter.CollaboratorPacket]) {
            items = items.filter(function (item) {
                return !(item instanceof PacketTicket ||
                    item instanceof CollaboratorTicket ||
                    item instanceof Stretch) &&
                    item.packet_id ===
                        Number(_this.state.itemSelected[Filter.CollaboratorPacket]);
            });
        }
        if (this.state.itemSelected &&
            this.state.itemSelected[Filter.TerminalSale]) {
            var value = this.state.itemSelected[Filter.TerminalSale];
            if (value === TerminalSale.Web) {
                items = items.filter(function (item) { return item.terminal === TerminalSale.Web; });
            }
            else if (value === TerminalSale.Virtual) {
                items = items.filter(function (item) { return item.terminal === TerminalSale.Virtual; });
            }
            else if (value === TerminalSale.POS) {
                items = items.filter(function (item) {
                    return !(item.terminal === TerminalSale.Web ||
                        item.terminal === TerminalSale.Virtual ||
                        item.terminal === TerminalSale.Virtual);
                });
            }
        }
        var _a = this.state, showDialog = _a.showDialog, itemSelected = _a.itemSelected;
        var _b = pax(items), _tickets = _b.tickets, _headers = _b.headers;
        this.headers = _headers;
        return (React.createElement(TicketSalesView, { action: this.props.action, onChangeDateFilter: this.handleChangeDateFilter, items: _tickets, itemSelected: itemSelected, headers: __spreadArray(__spreadArray([], headers, true), _headers, true), filters: filters, selectKeys: {
                listBy: 'listBy' + itemSelected[Filter.ListBy],
                terminalSale: 'terminalSale' + itemSelected[Filter.TerminalSale],
                afiliate: 'afiliate' + itemSelected[Filter.Afiliate],
                stretch: 'stretch' + itemSelected[Filter.Stretch],
                packet: 'packet' + itemSelected[Filter.Packet],
                operator: 'operator' + itemSelected[Filter.Operator],
                cs: 'stretch' +
                    itemSelected[Filter.CollaboratorStretch],
                cp: 'collaboratorPacket' +
                    itemSelected[Filter.CollaboratorPacket]
            }, options: {
                listByOptions: [
                    { name: T('seller'), value: 'seller' },
                    { name: T('operator'), value: 'operator' },
                ],
                terminalSaleOptions: [
                    { name: T('all'), value: 'all' },
                    { name: T(TerminalSale.Web), value: TerminalSale.Web },
                    { name: T('terminalVirtual'), value: TerminalSale.Virtual },
                    { name: T('terminalPhysicalPOS'), value: TerminalSale.POS }
                ],
                afiliateOptions: this.afiliateOptions,
                collaboratorOptions: this.collaboratorOptions,
                operatorOptions: this.operatorOptions,
                stretchOptions: this.stretchOptions,
                packetOptions: this.packetOptions,
                cpOptions: this.cpOptions,
                csOptions: this.csOptions
            }, onChange: this.handleChangeSelect, onExport: this.handleExport, onChangeFrom: this.handleChangeFrom, onChangeTo: this.handleChangeTo, onClickOK: this.handleClickOK, onSelectItem: this.handleOnSelectItem, total: total, totalNet: total, totalAllocation: total, loading: reports.loading, keyExtractor: this.keyExtractor, format: this.format, showDialog: showDialog, ticketToRender: this.ticketToRender, onToggle: this.handleToggle, onRefunded: this.handleRefunded, onChangeAdditionalNote: this.handleChangeAdditionalNote, listHeaders: listHeaders, onChangeHeader: function (value) {
                _this.setState({
                    listHeaders: value
                });
            } }));
    };
    TicketSales = __decorate([
        inject('store'),
        loading(function (props) {
            var parsed = queryString.parse(props.location.search);
            // console.log('parsed: ', parsed)
            var value = ListBy.DateSale;
            var data = getData(value === ListBy.DateSale ? typeList.Report : typeList.Calendar);
            var result;
            if (props.action === Action.Ticket) {
                result = props.store.reports.readGeneralSales;
            }
            else if (props.action === Action.Operator) {
                result = props.store.reports.readOperatorTickets;
            }
            return [
                result ? result(data) : undefined,
                props.store.users.read(),
                props.store.afiliateStore.read().then(function (afiliates) { return ({ afiliates: afiliates }); }),
                props.store.collaboratorStore
                    .read()
                    .then(function (collaborators) { return ({ collaborators: collaborators }); }),
                props.store.collaboratorStore
                    .readOperator()
                    .then(function (operators) { return ({ operators: operators }); }),
                props.store.stretches.read().then(function (stretches) { return ({ stretches: stretches }); }),
                props.store.collaboratorStretchesStore.read().then(function (cs) { return ({ cs: cs }); }),
                props.store.packetStore.read().then(function (packets) { return ({ packets: packets }); }),
                props.store.collaboratorPacketsStore.read().then(function (cp) { return ({ cp: cp }); })
            ];
        }),
        observer
    ], TicketSales);
    return TicketSales;
}(Component));
export default TicketSales;
var getContactName = function (contact) {
    return contact ? "".concat(contact.name, " ").concat(contact.surname) : '';
};
var getContactPhone = function (contact) {
    return (contact === null || contact === void 0 ? void 0 : contact.telephone) || '';
};
var getContactEmail = function (contact) {
    return (contact === null || contact === void 0 ? void 0 : contact.email) || '';
};
var getContactAdditional = function (contact) {
    return (contact === null || contact === void 0 ? void 0 : contact.additionalInformation) || '';
};
var getAfiliteFromPayments = function (payments) {
    if (!payments)
        return '';
    var afiliateName = '';
    var i = 0;
    while (afiliateName === '' && i < payments.length) {
        if (payments[i].afiliateName) {
            afiliateName = payments[i].afiliateName;
        }
        i++;
    }
    return afiliateName;
};
var datebookString = function (item) {
    var hours, minutes;
    var datebookToShow;
    if (item.day && item.month && item.year) {
        datebookToShow = new Date(item.year, item.month, item.day, 0, 0, 0, 0);
    }
    else {
        datebookToShow = item.datebook;
    }
    if (!item.datebook) {
        return '';
    }
    if (typeof item.hours !== 'undefined' &&
        item.hours !== null &&
        typeof item.minutes !== 'undefined' &&
        item.minutes !== null) {
        hours = item.hours;
        minutes = item.minutes;
    }
    else if (item.datebookNTZ) {
        hours = item.datebookNTZ.getUTCHours();
        minutes = item.datebookNTZ.getUTCMinutes();
    }
    else {
        hours = item.datebook.getHours();
        minutes = item.datebook.getMinutes();
    }
    var year = datebookToShow.getFullYear();
    var month = datebookToShow.getMonth() + 1;
    var day = datebookToShow.getDate();
    return "".concat(twoDigits(day), "/").concat(twoDigits(month), "/").concat(year, " ").concat(twoDigits(hours), ":").concat(twoDigits(minutes));
};
export var tramoHora = function (dateBook, hours, minutes) {
    if (dateBook) {
        var _hours = hours ? twoDigits(hours) : twoDigits(dateBook.getHours());
        var _minutes = minutes
            ? twoDigits(minutes)
            : twoDigits(dateBook.getMinutes());
        return "".concat(_hours, ":").concat(_minutes);
    }
    return '';
};
export var TypeTotal = {
    total: 'total',
    totalNet: 'totalNet',
    totalAllocation: 'totalAllocation'
};
var total = function (tickets, typeTotal) {
    var totalObject = {};
    tickets.reduce(function (sum, item) {
        if (item.daterefund)
            return sum;
        var money;
        if (!item.money) {
            // si no tiene moneda se pone EUR
            money = 'EUR';
        }
        else {
            money = item.money;
        }
        var temp = 0;
        if (typeTotal === TypeTotal.total) {
            temp = item.total;
        }
        else if (typeTotal === TypeTotal.totalNet) {
            temp = item.totalNet;
        }
        else if (typeTotal === TypeTotal.totalAllocation && item.hasAllocations) {
            temp = item.totalNet;
        }
        if (!sum[money]) {
            sum[money] = temp;
            return sum;
        }
        sum[money] += temp;
        return sum;
    }, totalObject);
    var totalString = '';
    Object.entries(totalObject).forEach(function (value, index, array) {
        if (index !== 0) {
            totalString += " ; ".concat(toNumberDecimal(Number(value[1])), " ").concat(value[0]);
        }
        else {
            // totalString += `${Number(value[1]).toFixed(2)} ${value[0]}`
            totalString += "".concat(toNumberDecimal(Number(value[1])), " ").concat(value[0]);
        }
    });
    return totalString;
};
var filters = [
    {
        name: 'all',
        filter: function (item) { return true; }
    },
    {
        name: 'actives',
        filter: function (item) { return item.daterefund === null; }
    }, {
        name: 'canceleds',
        filter: function (item) { return item.daterefund !== null; }
    }
];
export var getFromTo = function () {
    var _fromStorage = Storage.get('lastDateFrom');
    var _toStorage = Storage.get('lastDateTo');
    var _from;
    if (_fromStorage) {
        // pongo hora final del día para evitar que se queden items sin listar
        // por tener el día de una antigua búsqueda
        _from = new Date(_fromStorage);
    }
    else {
        _from = dateMonthsBefore(new Date(), 1);
    }
    var _to;
    if (_toStorage) {
        _to = new Date(_toStorage);
    }
    else {
        _to = new Date();
    }
    // pongo hora final del día para evitar que se queden items sin listar
    // por tener el día de una antigua búsqueda
    _to.setHours(23, 59, 59, 999);
    return {
        from: _from,
        to: _to
    };
};
export var getData = function (typeListValue) {
    var _a = getFromTo(), from = _a.from, to = _a.to;
    var data = {
        range: Range.Custom,
        typeList: typeListValue !== null && typeListValue !== void 0 ? typeListValue : typeList.Report,
        start: from,
        end: to
    };
    return data;
};
var handleExport = function (data, bookType, header) {
    var _header = [];
    header.forEach(function (h) {
        if (!h.selected) {
            return;
        }
        var name = h.name;
        var result = {
            v: name,
            t: 's',
            s: {
                alignment: { vertical: 'center' },
                border: {
                    bottom: { style: 'medium' },
                    up: { style: 'thin' },
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                },
                font: { bold: true, sz: 12, name: 'Courier' },
                fill: { fgColor: { rgb: 'E9E9E9' } }
            }
        };
        _header.push(result);
    });
    var ws = XLSX.utils.json_to_sheet([] /*{header: _header}*/);
    var _data = data.map(function (item) {
        var temp = {};
        header.forEach(function (h) {
            var _a, _b;
            if (!h.selected) {
                return;
            }
            var keyHead = (_a = h.exportHead) !== null && _a !== void 0 ? _a : h.head;
            if (keyHead === 'datecheck') {
                // parseo fechas
                if (typeof item[keyHead] === 'string') {
                    temp[keyHead] = item[keyHead];
                }
                else {
                    // compruebo si tiene fecha de uso ya que los paquetes carecen
                    temp[keyHead] = item[keyHead] ? toDateTime(item[keyHead]) : '';
                }
            }
            else if (keyHead === 'datebook') {
                if (typeof item[keyHead] === 'string') { // doy por hecho que ya tiene valor correcto
                    temp[keyHead] = item[keyHead];
                }
                else {
                    // compruebo si tiene fecha de uso ya que los paquetes carecen
                    temp[keyHead] = item[keyHead] ? datebookString(item) : '';
                }
            }
            else {
                temp[keyHead] = (_b = item[keyHead]) !== null && _b !== void 0 ? _b : '';
            }
        });
        return temp;
    });
    var row = 0;
    XLSX.utils.sheet_add_json(ws, [_header], {
        skipHeader: true,
        origin: row
    });
    row++;
    _data.forEach(function (item) {
        XLSX.utils.sheet_add_json(ws, [item], {
            skipHeader: true,
            origin: row
        });
        row++;
    });
    var EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    var CSV_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    var CSV_EXTENSION = '.csv';
    var EXCEL_EXTENSION = '.xlsx';
    var _type;
    var extension;
    switch (bookType) {
        case 'xlsx':
            extension = EXCEL_EXTENSION;
            _type = EXCEL_TYPE;
            break;
        case 'csv':
            extension = CSV_EXTENSION;
            _type = CSV_TYPE;
            break;
        default:
            extension = EXCEL_EXTENSION;
            _type = EXCEL_TYPE;
    }
    /*const wb = {
      Sheets: {
        data: ws
      },
      SheetNames: ['data']
    }*/
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'resultado');
    var eb = XLSX.write(wb, { bookType: bookType, type: 'array' });
    var blob = new Blob([eb], { type: _type });
    saveAs(blob, 'archivo' + extension);
};
var listHeaders = [
    {
        name: T('datecheck'),
        head: 'dateCheck',
        exportHead: 'datecheck',
        selected: true
    },
    {
        name: T('datebook'),
        head: 'dateBook',
        exportHead: 'datebook',
        selected: true
    },
    {
        name: T('numero'),
        head: 'numero',
        selected: true
    },
    {
        name: T('numberSI'),
        head: 'numberSI',
        selected: true
    },
    {
        name: T('terminal'),
        head: 'terminal',
        selected: true
    },
    {
        name: T('user'),
        head: 'user',
        exportHead: 'username',
        selected: true
    },
    {
        name: T('total'),
        head: 'total',
        selected: true
    },
    {
        name: T('totalNet'),
        head: 'totalNet',
        selected: true
    },
    {
        name: T('money'),
        head: 'money',
        selected: true
    },
    /*{
       name: T('hasAllocations'),
       head: 'hasAllocations',
       selected: true
     },*/
    {
        name: T('typeSale'),
        head: 'typeSale',
        selected: true
    },
    {
        name: T('contactName'),
        head: 'contactName',
        selected: true
    },
    {
        name: T('contactPhone'),
        head: 'contactPhone',
        selected: true
    },
    {
        name: T('contactEmail'),
        head: 'contactEmail',
        selected: true
    },
    {
        name: T('additionalInformation'),
        head: 'contactAdditional',
        selected: true
    },
    {
        name: T('status'),
        head: 'status',
        selected: true
    },
    {
        name: T('operatorName'),
        head: 'operatorName',
        selected: true
    },
    {
        name: T('afiliateName'),
        head: 'afiliateName',
        selected: true
    },
    {
        name: T('businessUnitName'),
        head: 'businessUnit',
        exportHead: 'businessUnitName',
        selected: true
    },
    {
        name: T('operationLineName'),
        head: 'operationLine',
        exportHead: 'operationLineName',
        selected: true
    },
    {
        name: T('serviceName'),
        head: 'stretch',
        exportHead: 'stretchName',
        selected: true
    },
    {
        name: T('packetName'),
        head: 'packet',
        exportHead: 'packetName',
        selected: true
    },
];
var pax = function (tickets) {
    var headers = [];
    tickets.forEach(function (ticket, index) {
        ticket.lines.forEach(function (line) {
            tickets[index][line.passengerCategoryName] = line.quantity;
            if (!headers.find(function (header) { return header === line.passengerCategoryName; })) {
                headers.push(line.passengerCategoryName);
            }
        });
    });
    return { tickets: tickets, headers: headers };
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketSales.tsx
// module id = 101
// module chunks = 0